<template>
  <div class="content mb-5">
    <b-row class="mb-6">
      <b-col cols="12">{{
        $t(
          "If you are installing WebTitan OTG 2 for Chromebooks, use the .PEM format certificate to import into Google Workspace."
        )
      }}</b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-3">
        <b-card>
          <b-col>
            <h3>{{ $t("SSL Certificate") }}</h3>
          </b-col>

          <b-col cols="12" class="mt-4">
            <b-button
              data-test-id="ssl-certificate-download-certificate"
              variant="secondary"
              :href="sslCertLink"
              >{{ $t("Download") }}</b-button
            >
          </b-col></b-card
        >
      </b-col>
      <b-col cols="6">
        <b-card>
          <b-col>
            <h3>{{ $t("PEM Certificate") }}</h3>
          </b-col>
          <b-col cols="12" class="mt-4">
            <b-button
              data-test-id="ssl-certificate-download-certificate"
              variant="secondary"
              :href="pemCertLink"
              >{{ $t("Download") }}</b-button
            >
          </b-col></b-card
        >
      </b-col>
    </b-row>
  </div>
</template>

<route>
{
  "name": "Customer Certificates",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  layout: "customer",
  data() {
    return {
      fetching: false,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("toast", ["displayToast"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    pemCertLink() {
      return `${process.env.VUE_APP_API_URL}/ssl/ca.pem`;
    },
    sslCertLink() {
      return `${process.env.VUE_APP_API_URL}/ssl/ca.der`;
    },
  },
  created() {
    this.setPageTitle(this.$t("Certificates"));
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "If a WebTitan certificate has not been installed and a user visits an HTTPS enabled website that is blocked by a policy, their browser will return a certificate error page instead of your WebTitan block page. To avoid this, download an SSL Certificate and import it into your user's browser."
      ),
    ]);
  },
};
</script>
